import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { FormatTypes } from 'Lib/Format';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(getLabelConfig(prefix), {
    [`${prefix}.Preparation.Balance`]: { defaultReadability: 0.1, defaultUom: 'g' },

    [`${prefix}.MeasurementsAndObservations.WaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
    [`${prefix}.MeasurementsAndObservations.InitialObservationDue`]: {
      format: { type: FormatTypes.Time, pattern: 'HH:mm' },
    },
    [`${prefix}.MeasurementsAndObservations.SecondObservationDue`]: {
      format: { type: FormatTypes.Time, pattern: 'HH:mm' },
    },

    [`${prefix}.Results.WaterTemperatureResults`]: { uom: '°C', format: { nearest: 1 } },
  });

export { getConfig };

export default {
  [qestIds.emersonClassification.AS_1289_3_8_1.rev2017]: getConfig,
};
